import type { Table as TableProps } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

import { TableHead, TableHeader, TableRow } from '@/_components';

interface DataTableProps<TData> {
  table: TableProps<TData>;
  className?: string;
  /** When true, header cells use square corners (no rounded top corners). */
  flatRoundedCorners?: boolean;
}

export function TablesHeader<TData>({ table, className, flatRoundedCorners }: DataTableProps<TData>) {
  return (
    <TableHeader flatRoundedCorners={flatRoundedCorners} className={className}>
      {table.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id} className="hover:bg-transparent dark:hover:bg-transparent">
          {headerGroup.headers.map((header) => {
            const { className, headerClassName } = header.column.columnDef.meta as {
              className?: string;
              headerClassName?: string;
            };

            return (
              <TableHead key={header.id} className={headerClassName || className}>
                {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
              </TableHead>
            );
          })}
        </TableRow>
      ))}
    </TableHeader>
  );
}
